import { DashboardCardLabel, DashboardCardValue } from 'components/Custom/spans';
import { formatDisplayInteger } from 'i18n/arabicDigits';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const MetricStack = styled.div`
  width: 100%;
`;

interface DashboardMetricContentProps {
  label: string;
  value: React.ReactNode;
}

/** Shared label + value layout for simple home dashboard stat cards. */
export const DashboardMetricContent: React.FC<DashboardMetricContentProps> = ({
  label,
  value,
}) => {
  const { i18n } = useTranslation();
  const displayValue =
    typeof value === 'number'
      ? formatDisplayInteger(value, i18n.language)
      : value;

  return (
  <MetricStack>
    <DashboardCardLabel>{label}</DashboardCardLabel>
    <DashboardCardValue>{displayValue}</DashboardCardValue>
  </MetricStack>
  );
};
